
import { Mixins, Component } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import * as modals from "@/lib/modals";

const systemModule = getModule(SystemModule);

@Component({
  name: modals.actionSummaryModal
})
export default class ActionSummaryModal extends Mixins(mixin) {
  get actionResults() {
    return systemModule.actionResults;
  }

  set actionResults(newValue) {
    systemModule.setActionResults(newValue);
  }

  get showModal() {
    return this.actionResults ? true : false;
  }

  set showModal(newValue) {
    newValue;
  }

  resetModal() {
    systemModule.setActionResults(null);
  }

  getErrorText(error) {
    if (Array.isArray(error)) return error.join(", ");
    return error;
  }
}
